import { Stack, Typography, Unstable_Grid2 as Grid, Chip, Avatar  } from '@mui/material';
import styles from './Contact.module.css';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import GitHubIcon from '@mui/icons-material/GitHub';
import { Link } from 'react-router-dom';

export default function Contact() {
    return (
        <div className={styles.container} id="contact">
            <Stack 
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
            >
                <Typography variant="h4" color="rgba(255, 255, 255, 87)">Contact</Typography>
                <Grid container rowSpacing={1} columnSpacing={1} display="flex" justifyContent="center" maxWidth="50vw" minWidth="380px">
                    <Avatar alt="GitHub" sx={{ bgcolor: "#333", width: 48, height: 48, margin: 1 }} component={Link} to={"https://github.com/zhonghan721"}>
                        <GitHubIcon fontSize="large" />
                    </Avatar>
                    <Avatar alt="LinkedIn" sx={{ bgcolor: "#0A66C2", width: 48, height: 48, margin: 1 }} component={Link} to={"https://www.linkedin.com/in/zhonghan-lim/"}>
                        <LinkedInIcon fontSize="large" />
                    </Avatar>
                    <Avatar alt="Email" sx={{ bgcolor: "#EA4335", width: 48, height: 48, margin: 1 }} component={Link} to={"mailto:limzh.21@gmail.com"}>
                        <EmailIcon fontSize="large" />
                    </Avatar>
                </Grid>                
            </Stack>
            <div className={styles.divider} />
        </div>
    );
}